import { SvgHouseSearching } from "assets/icons/js/SvgHouseSearching";

// style
import "./style.scss";

export const ListingDiscontinued = () => {
	return (
		<div className="listing__discontinued">
			<SvgHouseSearching />
			<h2>Oops, this home is no longer available on our network!</h2>
			<p>We recommend you to find similar homes</p>
			{/* <button>View Similar Homes</button> */}
		</div>
	);
};
